import useSiteStore from '../store/siteStore.js';
import { darkTheme, lightTheme, darkThemeChristmas, lightThemeChristmas } from '../styles/colorSchemes/index.js';
import { isChristmasSeason } from '../utils/dateUtils.js';

export const useAppTheme = () => {
    const darkMode = useSiteStore(state => state.darkMode);
    const setDarkMode = useSiteStore(state => state.setDarkMode);
    
    // Select theme based on season
    const isChristmas = isChristmasSeason();
    const activeDarkTheme = isChristmas ? darkThemeChristmas : darkTheme;
    const activeLightTheme = isChristmas ? lightThemeChristmas : lightTheme;
    
    return {
        isDarkMode: darkMode,
        toggleDarkMode: () => setDarkMode(!darkMode),
        colors: darkMode ? activeDarkTheme : activeLightTheme,
        darkTheme: activeDarkTheme,
        lightTheme: activeLightTheme,
        isChristmas,
    };
};

export default useAppTheme;
